export const SITE_URL = 'https://ai.psyhelp.info';
export const SITE_NAME = 'AI PSY HELP';

